import React from 'react';
import cn from 'classnames';

function noPaddingOverride(props) {
  return !props.className || props.className.indexOf('pv') === -1;
}

const Section = props => (
  <section
    className={cn(
      {
        pv5: noPaddingOverride(props),
        'pv6-l': noPaddingOverride(props),
      },
      props.className
    )}
  >
    {props.children}
  </section>
);

export default Section;



// WEBPACK FOOTER //
// ./src/components/Section.js